module.exports = __webpack_public_path__ + "static/img/11_phase_function_Paper_PointsHejduk_Prediction.a7c04d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/11_phase_function_Paper_PointsHejduk_Prediction.png
// module id = VUy5
// module chunks = 0